module.exports = "/_next/static/images/slide10-57a95c60d5805162372612e44e30c9fd.webp";